import React, { useState, useEffect, useRef, useCallback } from "react";
import Money from "../../../Assets/Money.png";
import Virtual from "../../../Assets/Virtual.png";
import Invest from "../../../Assets/Invest.png";
import Saves from "../../../Assets/Saves.png";
import "../../../App.css";

const Payment = () => {
  const [activeSection, setActiveSection] = useState("PAYMENTS");
  const [linePosition, setLinePosition] = useState(0);
  const [initialRender, setInitialRender] = useState(true);
  const activeSectionRef = useRef(null);

  const handleSection = useCallback((section) => {
    setActiveSection(section);
    const sectionElement = document.getElementById(section);
    const line = document.querySelector(".line");

    if (sectionElement && line) {
      const sectionTop = sectionElement.offsetTop - 7.78 * 16;
      const lineStartPosition = line.offsetTop;
      const lineEndPosition = sectionTop + sectionElement.offsetHeight / 2;

      animateLine(line, lineStartPosition, lineEndPosition);
    }
    // console.log("rerender4");
  }, []);

  const animateLine = (line, startPosition, endPosition) => {
    const duration = 300;
    let startTime;

    const moveLine = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;

      const newPosition =
        progress < duration
          ? startPosition +
            ((endPosition - startPosition) * progress) / duration
          : endPosition;

      line.style.top = `${newPosition}px`;

      if (progress < duration) {
        requestAnimationFrame(moveLine);
      }
    };

    requestAnimationFrame(moveLine);
    // console.log("rerender3");
  };

  useEffect(() => {
    handleSection("PAYMENTS");
    setInitialRender(false);
    // console.log("rerender1");
  }, [handleSection]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".sections");
      let closestSection = sections[0];

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 10.85 * 16;
        if (window.scrollY >= sectionTop) {
          closestSection = section;
        }
      });

      const newActiveSection = closestSection.getAttribute("data-section");
      if (newActiveSection !== activeSectionRef.current) {
        setActiveSection(newActiveSection);
        activeSectionRef.current = newActiveSection;
      }
    };
    // console.log("rerender2");
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeSection]);

  const texxtColor1 =
    activeSection === "PAYMENTS" || initialRender ? "#017A59" : "#e8e9eb";
  const texxtColor2 =
    activeSection === "VIRTUAL CARDS" || initialRender ? "#017A59" : "#e8e9eb";
  const texxtColor3 =
    activeSection === "SAVINGS" || initialRender ? "#017A59" : "#e8e9eb";
  const texxtColor4 =
    activeSection === "INVESTMENTS" || initialRender ? "#017A59" : "#e8e9eb";

  const textCoolor1 =
    activeSection === "PAYMENTS" || initialRender ? "#1D1D1F" : "#e8e9eb";
  const textCoolor2 =
    activeSection === "VIRTUAL CARDS" || initialRender ? "#1D1D1F" : "#e8e9eb";
  const textCoolor3 =
    activeSection === "SAVINGS" || initialRender ? "#1D1D1F" : "#e8e9eb";
  const textCoolor4 =
    activeSection === "INVESTMENTS" || initialRender ? "#1D1D1F" : "#e8e9eb";
  return (
    <section className="hidden sm:flex justify-around relative">
      <div className="line-container">
        <div
          className={`${"border-l-2 border-[#017a59] h-[10.875rem] transition-all duration-300"} line`}
          // style={{ top: `calc(${linePosition}px - 4.38rem)` }}
        ></div>
      </div>
      <div className="pt-[5.69rem] cursor-pointer">
        <h1
          style={{ color: `${texxtColor1}` }}
          onClick={() => handleSection("PAYMENTS")}
          className={`pb-[1rem] text-[${
            activeSection === "PAYMENTS" || initialRender
              ? "#017A59"
              : "#e8e9eb"
          }] text-[1.375rem] font-semibold leading-[2rem] sections`}
          data-section="PAYMENTS"
          id="PAYMENTS"
        >
          PAYMENTS
        </h1>
        <p
          style={{ color: `${textCoolor1}` }}
          className="pb-[5.38rem]  mac:text-[1.25rem] xl:text-[1.1rem] lg:text-[0.9rem] font-medium leading-[1.75rem] tracking-[-0.025rem]"
        >
          Make (Local and international transactions)
          <br />
          and scheduled payments
        </p>

        <h1
          style={{ color: `${texxtColor2}` }}
          onClick={() => handleSection("VIRTUAL CARDS")}
          className={`pb-[1rem] text-[${
            activeSection === "VIRTUAL CARDS" ? "#017A59" : "#e8e9eb"
          }] text-[1.375rem] font-semibold leading-[2rem]  `}
          data-section="VIRTUAL CARDS"
          id="VIRTUAL CARDS"
        >
          VIRTUAL CARDS
        </h1>
        <p
          style={{ color: `${textCoolor2}` }}
          className="pb-[5.38rem]  mac:text-[1.25rem] xl:text-[1.1rem] lg:text-[0.9rem] font-medium leading-[1.75rem] tracking-[-0.025rem]"
        >
          One tool, one easy way to transact business
          <br />
          seemlessly.
        </p>

        <h1
          style={{ color: `${texxtColor3}` }}
          onClick={() => handleSection("SAVINGS")}
          className={`pb-[1rem] text-[${
            activeSection === "SAVINGS" ? "#017A59" : "#e8e9eb"
          }] text-[1.375rem] font-semibold leading-[2rem] `}
          data-section="SAVINGS"
          id="SAVINGS"
        >
          SAVINGS
        </h1>
        <p
          style={{ color: `${textCoolor3}` }}
          className="pb-[5.38rem]  mac:text-[1.25rem] xl:text-[1.1rem] lg:text-[0.9rem] font-medium leading-[1.75rem] tracking-[-0.025rem]"
        >
          Attaining financial success is possible, but <br />
          only through strategic savings.
        </p>

        <h1
          style={{ color: `${texxtColor4}` }}
          onClick={() => handleSection("INVESTMENTS")}
          className={`pb-[1rem] text-[${
            activeSection === "INVESTMENTS" || initialRender
              ? "#017A59"
              : "#e8e9eb"
          }] text-[1.375rem] font-semibold leading-[2rem]  `}
          data-section="INVESTMENTS"
          id="INVESTMENTS"
        >
          INVESTMENTS
        </h1>
        <p
          style={{ color: `${textCoolor4}` }}
          className="pb-[6.38rem]  mac:text-[1.25rem] xl:text-[1.1rem] md:text-sm lg:text-[0.9rem] font-medium lg:leading-[1.75rem] tracking-[-0.025rem]"
        >
          Generate positive returns over a period of time by <br />
          investing with us today.
        </p>
      </div>

      {activeSection === "PAYMENTS" && (
        <div>
          <img
            src={Money}
            alt=""
            className="object-cover mac:w-[44.1875rem] xl:w-[42.1875rem] lg:w-[32.1875rem] lg:h-[44.1875rem] pro:w-[25.1875rem] pro:h-[27rem] pro:mt-5 lg:mt-0 md:w-[19rem] md:h-[22rem] md:mt-12"
          />
        </div>
      )}

      {activeSection === "VIRTUAL CARDS" && (
        <div>
          <img
            src={Virtual}
            alt=""
            className="object-cover mac:w-[44.1875rem] xl:w-[42.1875rem] lg:w-[32.1875rem] lg:h-[44.1875rem] pro:w-[25.1875rem] pro:h-[25rem] pro:mt-[9.5rem] lg:mt-0 md:w-[19rem] md:h-[22rem] md:mt-[10rem]"
          />
        </div>
      )}

      {activeSection === "SAVINGS" && (
        <div className="">
          <img
            src={Saves}
            alt=""
            className="object-cover mac:w-[44.1875rem] xl:w-[42.1875rem] lg:w-[32.1875rem] lg:h-[44.1875rem] pro:w-[25.1875rem] pro:h-[27rem] pro:mt-[19rem] lg:mt-0 md:w-[19rem] md:h-[22rem] md:mt-[20rem]"
          />
        </div>
      )}

      {activeSection === "INVESTMENTS" && (
        <div className="">
          <img
            src={Invest}
            alt=""
            className="object-cover mac:w-[44.1875rem] xl:w-[42.1875rem] lg:w-[34.1875rem] lg:h-[44.1875rem] pro:w-[25.1875rem] pro:h-[27rem] pro:mt-[27rem]lg:mt-0 md:w-[19rem] md:h-[22rem] md:mt-[27rem] lg:mt-0"
          />
        </div>
      )}
    </section>
  );
};

export default Payment;
